module.exports = __webpack_public_path__ + "img/settings/Nimble.8b0226.png";